import React from 'react';
import { useIntl } from 'react-intl';

import { Alert } from '@mui/material';

export enum GenericErrorType {
  error = 'error',
  info = 'info',
}

export interface GenericErrorProps {
  type: GenericErrorType;
  intlIdTitle: string;
  intlProps?: { [key: string]: string };
}

const GenericError: React.FC<GenericErrorProps> = ({ type, intlIdTitle, intlProps }) => {
  const intl = useIntl();

  return (
    <Alert variant="filled" severity={type}>
      {intl.formatMessage({ id: intlIdTitle }, intlProps)}
    </Alert>
  );
};

export default GenericError;
